import { FC } from "react";
import * as styles from "./Video.module.scss";
import ReactPlayer from "react-player";

export interface VideoProps {
  title?: string;
  url: string;
}

const Video: FC<VideoProps> = ({ title, url }) => {
  return (
    <figure className={styles.root}>
      <ReactPlayer url={url} width="100%" height="100%" controls={true} />
      {title && <figcaption className={styles.caption}>{title}</figcaption>}
    </figure>
  );
};

export default Video;
